import { render } from "./DeleteEventDialog.vue?vue&type=template&id=e15f6480&scoped=true&ts=true&lang=pug"
import script from "./DeleteEventDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteEventDialog.vue?vue&type=script&lang=ts"

import "./DeleteEventDialog.vue?vue&type=style&index=0&id=e15f6480&scoped=true&lang=css"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e15f6480"]])

export default __exports__